import React, { Component } from 'react';

//Custom components
import { DropUploader } from '../../Utilities/DropUploader'
import { ModalDialog } from '../../Utilities/ModalDialog'

//Material UI
import { Typography, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

//Data services
import { saveVideoAPI, getVideo } from '../../../DataServices/VideoService'
import {  getVideoCover } from '../../../DataServices/Utility'

//const convertBlobToBase64 = async (blob) => { // blob data
//    return await blobToBase64(blob);
//}

const blobToBase64 = blob => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export class VideoUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemCount: 0,
            processing:false
        }
    }
    createVideoCover = async (file) => {
        try {
            // get the frame at 1.5 seconds of the video file
            const cover = await getVideoCover(file, 1.5);
            // print out the result image blob
            return cover;
        } catch (ex) {
            console.log("ERROR: ", ex);
            return "error";
        }
    }
    handleSaveVideo = async (file) => {
        const blob = await this.createVideoCover(file);
        let cover = "";
        if (blob) {
            const thumbB64 = await blobToBase64(blob);
            let thumbB64Split = thumbB64.split(',');
            if (thumbB64Split.length > 1) {
                cover = thumbB64Split[1]
            }
        }

        const id = await saveVideoAPI(file, this.props.library.id, this.props.appIdentifier, cover, this.props.user.accessToken, this.props.user.userID);
        if (id) {
            const video = await getVideo(id);
            if (video) {
                this.props.updateParent(video);
                this.setState({ itemCount: this.state.itemCount + 1 });
            }
        }
    }
    updateStateForNewPhoto = (base64result) => {
        //Update State to display new photo
        const itemCount = this.state.itemCount + 1;
        this.setState({
            currentUpload: base64result,
            itemCount: itemCount
        });
    }

    handleClose = () => {
        this.setState({
            currentUpload: "",
            itemCount: 0
        })
        this.props.handleClose();
    }
    toggleProcessing = (status) => {
        if (status != null) {
            this.setState({ processing: status });
        }
        else {
            this.setState({ processing: !this.state.processing });
        }  
    }

    //render
    summaryText = (count) => {
        if (count === 1) {
            return "Uploaded 1 video";
        }
        else {
            return "Uploaded " + count + " videos";
        }
    }
    uploadingMessage = () => {
        return (
            <Box sx={{ display: "flex", width: "100%", my: "auto", minHeight: { md: 300 }, minWidth: { sm: 500 }, textAlign: "center", background: "transparent" }}>
                <Box sx={{ m: "auto" }}>
                    <Typography sx={{ color: theme => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary, mb: 2, fontWeight: 600 }}>
                        Uploading
                    </Typography>
                    <CircularProgress color="secondary" />
                </Box>
            </Box>
        )
    }
    uploader = () => {
        return (
            <DropUploader
                dark={this.props.dark}
                type={0}
                multi={this.props.multi}
                label="Project Profile Image"
                fileType="video"
                onDrop={this.updateStateForNewPhoto}
                handleSave={this.handleSaveVideo}
                photoB64={this.state.currentUpload ? this.state.currentUpload : ""}
                height={250}
                width={"100%"}
                toggleProcessing={this.toggleProcessing}
            />
        )
    }
    alerts = () => {
        return (
            <Box sx={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                mt: this.state.itemCount > 0 || this.state.processing ? 2 : 0,
                px: this.props.width < 600 ? 1 : 2,
            }}>
                <Stack>
                    <Box sx={{ display: "flex", width: "100%", justifyContent: "center", }}>
                        {(!this.state.processing && this.state.itemCount > 0) &&
                            <Typography sx={{ display: "inline-block", mr: 2, color: theme => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary }}>
                                {this.summaryText(this.state.itemCount)}
                            </Typography>}
                        {(!this.state.processing && this.state.itemCount > 0) && <CheckCircleOutlineIcon color="success" />}
                        {this.state.processing &&
                            <Box sx={{ m: "auto", display: "flex" }}>
                                <Typography sx={{ mr: 2, my: "auto", color: theme => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary }}>
                                    Uploading
                                </Typography>
                                <CircularProgress color="secondary" />
                            </Box>
                        }

                    </Box>
                </Stack>
            </Box>
        )
    }

    render() {
        return (
            <ModalDialog
                dark={this.props.dark}
                fullWidth={true}
                maxWidth={"xs"}
                fullScreen={this.props.width < 600}
                closeLabel="Close"
                handleClose={this.handleClose}
                show={this.props.open}
                title="Upload New Video"
            >
                <Stack sx={{ pt: { sm: 1 }, pb: { sm: 2 } }} >
                    {this.uploader()}
                    {this.alerts()}
                </Stack>
            </ModalDialog>
        );
    }
}

